import React, { Component } from 'react';
import PropTypes from 'prop-types';
import radium from 'radium';
import { VelocityComponent } from 'velocity-react';

// import plusIcon from '../../../images/ic_add.png';

const Loading = props => <div style={props.style}> loading... </div>;

Loading.propTypes = {
  style: PropTypes.shape({}),
};

const Toggle = props => {
  const style = props.style;
  // const height = style.height;
  // const width = style.width;
  // const midHeight = height * 0.5;
  // const points = `0,0 0,${height} ${width},${midHeight}`;
  return (
    <div style={style.base}>
      <div style={style.wrapper}>{/* <img src={plusIcon} />*/}</div>
    </div>
  );
};

Toggle.propTypes = {
  style: PropTypes.shape({}),
};

const Header = props => {
  const style = props.style;
  return (
    <div style={style.base}>
      <div style={style.title}>{props.node.name}</div>
    </div>
  );
};

Header.propTypes = {
  style: PropTypes.shape({}),
  node: PropTypes.shape({
    name: PropTypes.string,
  }),
};

const GeographyHeader = props => {
  const style = props.style;
  return (
    <div style={style.base}>
      <div style={style.title}>{props.node.name}</div>
    </div>
  );
};

GeographyHeader.propTypes = {
  style: PropTypes.shape({}),
  node: PropTypes.shape({
    name: PropTypes.string,
  }),
};

class Container extends Component {
  constructor(props) {
    super(props);
    this.renderToggle = this.renderToggle.bind(this);
    this.renderToggleDecorator = this.renderToggleDecorator.bind(this);
  }
  renderToggle() {
    const animations = this.props.animations;
    if (!animations) {
      return this.renderToggleDecorator();
    }
    return (
      <VelocityComponent
        ref={velocity => {
          this.velocity = velocity;
        }}
        duration={animations.toggle.duration}
        animation={animations.toggle.animation}
      >
        {this.renderToggleDecorator()}
      </VelocityComponent>
    );
  }
  renderToggleDecorator() {
    const { style, decorators } = this.props;
    return <decorators.Toggle style={style.toggle} />;
  }
  render() {
    const {
      style,
      decorators,
      terminal,
      onMouseDown,
      node,
      tabSelected,
      treeData,
    } = this.props;
    return (
      <div
        ref={clickable => {
          this.clickable = clickable;
        }}
        onMouseDown={onMouseDown}
        style={style.container}
        className="tree-container"
      >
        {!terminal ? this.renderToggle() : null}
        {tabSelected !== 'geographies' ? (
          <decorators.Header node={node} style={style.header} />
        ) : (
          <decorators.GeographyHeader
            node={node}
            style={style.header}
            treeData={treeData}
          />
        )}
      </div>
    );
  }
}

Container.propTypes = {
  style: PropTypes.shape({}).isRequired,
  decorators: PropTypes.shape({}).isRequired,
  terminal: PropTypes.bool.isRequired,
  onMouseDown: PropTypes.func.isRequired,
  animations: PropTypes.oneOfType([PropTypes.object, PropTypes.bool])
    .isRequired,
  node: PropTypes.shape({}).isRequired,
  tabSelected: PropTypes.string,
  treeData: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
};

module.exports = {
  Loading,
  Toggle,
  Header,
  GeographyHeader,
  Container: radium(Container),
};
